// extracted by mini-css-extract-plugin
export var auctionHistoryItem = "HistoryItem_auctionHistoryItem__71auz";
export var imgWrapper = "HistoryItem_imgWrapper__-KUKO";
export var img = "HistoryItem_img__cw87G";
export var textDesc = "HistoryItem_textDesc__5+iAu";
export var textDate = "HistoryItem_textDate__ebA3X";
export var textUserLink = "HistoryItem_textUserLink__BZlET";
export var textPrice = "HistoryItem_textPrice__m-ltz";
export var rotate = "HistoryItem_rotate__Dj0NB";
export var dotty = "HistoryItem_dotty__Qw4vI";